import emailjs from "emailjs-com";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useMemo, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";


import Poster1 from "./Poster1.jpg";
import poster3 from "./poster3.jpg";


// Product Images
import img1 from "./kesar peda.png";
import img2 from "./home page barfi.png";
import img3 from "./lauki halva.png";
import img4 from "./gulab jamun.png";
import img5 from "./fancydryfruit3.jpg";
import img6 from "./rosogulla.png";
import img7 from "./malai barfi.png";
import img8 from "./dinkladdu2.png";
import img9 from "./sugarfree2.png";
import img10 from "./anjir barfi.png";
import img11 from "./anjir peda.png";
import img12 from "./kajukatli.png";
import img13 from "./gibli.jpg"

import Snacks1 from "./khaman dhokla.png";
import Snacks2 from "./sev snacks.png";
import Snacks3 from "./gathiya.jpg";
import Snacks4 from "./khakhra snacks.png";



function Home({ scrollToContact }) {
  const footerRef = useRef(null);

  // === Scroll Reveal ===
  useEffect(() => {
    const reveals = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right, .slide-up"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    reveals.forEach((r) => observer.observe(r));
    return () => observer.disconnect();
  }, []);

useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key.toLowerCase() === "t") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  
  // === Carousel ===
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  // === Stats ===
  const stats = useMemo(
    () => [
      { icon: "fas fa-smile", label: "Happy Customers", target: 100000 },
      { icon: "fas fa-gift", label: "Gifts Delivered", target: 2437 },
      { icon: "fas fa-star", label: "5-Star Reviews", target: 173 },
      {
        icon: "fas fa-heart",
        isStatic: true,
        bigText: "30+",
        smallText: "Years of Experience",
      },
    ],
    []
  );

  const [counts, setCounts] = useState(Array(stats.length).fill(0));

useEffect(() => {
  const handleKeyDown = (event) => {
    if (event.key.toLowerCase() === "t") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  document.addEventListener("keydown", handleKeyDown);
  return () => document.removeEventListener("keydown", handleKeyDown);
}, []);

  useEffect(() => {
    const duration = 6000;
    const intervalMs = 50;
    const totalSteps = duration / intervalMs;

    const intervals = stats.map((stat, index) => {
      if (stat.isStatic) return null;

      let current = 0;
      const increment = stat.target / totalSteps;

      const intervalId = setInterval(() => {
        current += increment;
        setCounts((prev) => {
          const updated = [...prev];
          updated[index] =
            current >= stat.target ? stat.target : Math.ceil(current);
          return updated;
        });

        if (current >= stat.target) clearInterval(intervalId);
      }, intervalMs);

      return intervalId;
    });

    return () => intervals.forEach((i) => i && clearInterval(i));
  }, [stats]);

  // === Scroll to Contact ===
  useEffect(() => {
    if (scrollToContact && footerRef.current) {
      footerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [scrollToContact]);

  // === Product Arrays ===
  const bestSellingProducts = [
    { name: "Peda", img: img1 },
    { name: "Barfi", img: img2 },
    { name: "Lauki Halva", img: img3 },
    { name: "Gulab Jamun", img: img4 },
  ];

  const specialProducts = [
    { name: "Fancy Dry Fruit", img: img5 },
    { name: "Bengal Sweets", img: img6 },
    { name: "Barfi", img: img7 },
    { name: "Dink Laddu", img: img8 },
  ];

  const sugarFreeProducts = [
    { name: "Sugar-Free Ladoo", img: img9 },
    { name: "Sugar-Free Barfi", img: img10 },
    { name: "Sugar-Free Peda", img: img11 },
    { name: "Sugar-Free Kaju Katli", img: img12 },
  ];

  const snacks = [
    { name: "Dhokla", img: Snacks1 },
    { name: "Namkeen Sev", img: Snacks2 },
    { name: "Gathiya", img: Snacks3 },
    { name: "Khakhra", img: Snacks4 },
  ];

  // === Testimonials ===
  const testimonials = [
    { quote: "Mava Barfi tastes Awesome.", author: "Amita Gonsalves" },
    {
      quote:
        "Will definitely visit again, Highly recommended! Maharaha halva was very tasty and the staff was very polite.",
      author: "Neha Chakrobarty",
    },
    {
      quote:
        "Authentic taste that reminds me of my hometown. The sweets are made with care and the quality is evident in every bite.",
      author: "Ramesh Vyas",
    },
    {
      quote:
        "The farsans are incredibly crispy and fresh. They stay good for days and go perfectly with tea. Loved the variety!",
      author: "Sonal Girnayek",
    },
    {
      quote:
        "A must-visit for anyone who enjoys traditional Indian sweets. Their jalebi and gulab jamun are simply unmatched.",
      author: "Harshit Aher",
    },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  // === Scroll-to-top button ===
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-container">
      {/* Hero Carousel */}
      <section className="carousel-section reveal">
        <Slider {...carouselSettings}>
          <div>
            <img src={Poster1} alt="Poster 1" />
          </div>
          <div>
            <img src={poster3} alt="Poster 3" />
          </div>
        </Slider>
      </section>

     {/* About Section */}
<section className="about-section">
  {/* Left Side - Experience Card */}
  <div className="about-left">
      {/* Left Image */}
      <img src={img13} alt="Left" className="side-img left-img" />

      {/* Main Card */}
      <div className="experience-card">
        <h3>30+</h3>
        <p>Years of Experience</p>
      </div>

      {/* Right Image */}
      <img src={img2} alt="Right" className="side-img right-img" />
    </div>

  {/* Right Side - Content */}
  <div className="about-right">
    <h4 className="about-subtitle">About Shiv Shakti Sweets</h4>
    <h2 className="about-title">Excellence In Every Bite Of Our Sweets, Snacks & Treats</h2>

    <ul className="about-list">
      <li>Craftsmanship Beyond Compare</li>
      <li>Quality Redefined</li>
      <li>A Symphony of Flavors</li>
      <li>Perfect Gifts, Cherished Moments</li>
    </ul>

    {/* Read More Button */}
    <Link to="/about" className="read-more-btn">
      Read More →
    </Link>
  </div>
</section>

      {/* Icons */}
      <section className="icons-section reveal-left">
        <div className="icon-box">
          <i className="fas fa-leaf"></i>
          <p>100% Vegetarian</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-ban"></i>
          <p>No Preservatives</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-heart"></i>
          <p>Hand Made with Love</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-star"></i>
          <p>Best Quality</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-seedling"></i>
          <p>Fresh Ingredients</p>
        </div>
      </section>

      {/* Products */}
      <ProductSection title="Best Selling Products" products={bestSellingProducts} />
      <ProductSection title="Special Products" products={specialProducts} />

      {/* Stats */}
      <section className="stats-section reveal">
        {stats.map((stat, index) => (
          <div className="stat-box" key={index}>
            <i className={stat.icon}></i>
            {stat.isStatic ? (
              <>
                <h2>{stat.bigText}</h2>
                <p>{stat.smallText}</p>
              </>
            ) : (
              <>
                <h2>{counts[index].toLocaleString()}</h2>
                <p>{stat.label}</p>
              </>
            )}
          </div>
        ))}
      </section>

      {/* More Products */}
      <ProductSection title="Our Range of Snacks" products={snacks} />
      <ProductSection title="Sugar Free Products" products={sugarFreeProducts} />

      {/* Trust Icons */}
      <h2 className="icons-title reveal">You Can Trust Us</h2>
      <section className="icons-section reveal-right">
        <div className="icon-box">
          <i className="fas fa-utensils"></i>
          <p>Food License</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-certificate"></i>
          <p>ISO Certified</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-shield-alt"></i>
          <p>Safe & Hygienic</p>
        </div>
        <div className="icon-box">
          <i className="fas fa-flag"></i>
          <p>Specialize in Indian Sweets</p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section reveal">
        <h2>What Our Customers Say</h2>
        <div class="testimonial-container">
        <div className="testimonial-slide">
          <p className="testimonial-quote">
            “{testimonials[currentTestimonial].quote}”
          </p>
          <p className="testimonial-author">
            – {testimonials[currentTestimonial].author}
          </p>
        </div>
        </div>
      </section>
{/* Email Popup Form */}
<div className="email-popup">
  <div className="popup-content">
    <span
      className="close-btn"
      onClick={() =>
        document.querySelector(".email-popup").classList.remove("show")
      }
    >
      &times;
    </span>
    <h3>Send us a Message</h3>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        emailjs
          .sendForm(
            "service_4vy1tdp",    // replace
            "template_0r0nqrt",   // replace
            e.target,
            "2LPLtOuukAp3pU3IT"     // replace
          )
          .then(
            () => {
              alert("Message sent successfully!");
              e.target.reset();
              document.querySelector(".email-popup").classList.remove("show");
            },
            (error) => {
              alert("Failed to send message.");
              console.error(error.text);
            }
          );
      }}
    >
      <input type="text" name="user_name" placeholder="Your Name" required />
      <input type="email" name="user_email" placeholder="Your Email" required />
      <textarea name="message" placeholder="Your Message" required />
      <button type="submit">Send</button>
    </form>
  </div>
</div>


      {/* Footer */}
      <footer className="footer reveal floating-footer" ref={footerRef}>
        <div className="footer-left">

          <div className="map-section">
            <iframe
              title="Virtue Crennovative Solutions Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.5277793448135!2d72.7823587!3d19.426873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7abc6ca81a485%3A0xe7090a060315deba!2sShiv%20Shakti%20Sweets%20And%20Farsans!5e0!3m2!1sen!2sin!4v1721720023877!5m2!1sen!2sin"
              loading="lazy"
              allowFullScreen=""
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        
        
          <div className="address-section">
            <p className="footer-heading">Our Address</p>
            <p className="footer-address">
              SHOP NO.07, THOMAS SMRUTI, DESILVA NAGAR, NALEGAON SATPALA,
              <br />
              NALASOPARA WEST, VASAI, PALGHAR-401203, Maharashtra
            </p>
          </div>

          <div className="contact-info">
  <p className="footer-heading">Contact's</p>
  <p>Call us On: +91 7028249896</p>
  <p>Or: +91 9561996917</p>
</div>
</div>

        <div className="footer-right">

          {/* Quick Links */}
          <div className="quick-links">
            <p className="footer-heading">Quick Links</p>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
              <li>
                <a href="/products">Products</a>
              </li>
              <li className="nav-item">
  <span className="nav-link">
    Contact
    <span className="hover-text">Links on your Right👉 or below 👇</span>
  </span>
</li>


            </ul>
          </div>
</div>
          <div className="social-section">
  <p className="footer-heading">Our Social Media</p>
  <div className="social-buttons">
    <a
      href="https://www.instagram.com/shivshaktii_sweets/"
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn"
    >
      <i className="fab fa-instagram"></i>
    </a>
    <a
      href="https://www.facebook.com/profile.php?id=61578899273637"
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn"
    >
      <i className="fab fa-facebook"></i>
    </a>
    <a
      href="https://wa.me/7028249896"
      target="_blank"
      rel="noopener noreferrer"
      className="social-btn"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
    <button
  className="social-btn"
  onClick={() => document.querySelector(".email-popup").classList.add("show")}
>
  <i className="fas fa-envelope"></i>
</button>

  </div>
</div>


        <div 
        onClick={() => window.open("https://www.virtuecrennovativesolutions.com/", "_blank")}
        className="site-footer-note">
          <p>Thank you for visiting our website. Have a wonderful day! | © 2025 Raghuvir Shivshkakti Sweets. All rights reserved | Designed and developed by VirtueCrennovativeSolutions</p>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {showButton && (
        <button
          className="scroll-to-top"
          onClick={scrollToTop}
          title="Back to top"
        >
          ↑
        </button>
      )}
    </div>
  );
}

function ProductSection({ title, products }) {
  return (
    <section className="products-section reveal" id="products">
      <h2>{title}</h2>
      <div className="products-grid">
        {products.map((product, i) => (
          <div key={i} className="product-card slide-up">
            <img src={product.img} alt={product.name} />
            <p>{product.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Home;
